import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import HttpV2ReaderForm from '../forms/http-v2-reader-form';
import { httpV2ReaderValidationSchema } from '../schema/httpV2Reader.js';

export default function HttpV2ReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'HTTP V2 Reader Node Details',
        altText: 'HTTP V2 Reader Node',
        defaultLabel: 'HTTP V2 Reader Node',
      }}
    >
      <CommonNode FormComponent={HttpV2ReaderForm} schemaResolver={httpV2ReaderValidationSchema} />
    </NodeProvider>
  );
}
